import { render, staticRenderFns } from "./PDFSettingsPage.vue?vue&type=template&id=39510b4b&"
import script from "./PDFSettingsPage.vue?vue&type=script&lang=js&"
export * from "./PDFSettingsPage.vue?vue&type=script&lang=js&"
import style0 from "./PDFSettingsPage.vue?vue&type=style&index=0&id=39510b4b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports